import { useCallback } from "react";
import { useDispatch } from "react-redux";

import useHandbookLvl from "pages/HandBook/hooks/useHandbookLvl";
import { handBookActions } from "pages/HandBook/model/slice";
import { localChangeHandbookTemplate } from "pages/HandBook/model/thunks";

import { useTypedSelector } from "app/store/typedUseSelector";

import { getChangedFields } from "utils/formHelpers/getChangedFields";
import { generateStorageKey } from "utils/helpers/generateStorageKey";

const useHandBooksTemplatesRow = (itemId: number) => {
  const dispatch = useDispatch();
  const { handbookLvl } = useHandbookLvl();
  const templateEditings = useTypedSelector((state) => state.handBookReducer.templateEditings);
  const editings = templateEditings[handbookLvl];
  const isEditing = templateEditings.isEditing;
  const key = generateStorageKey({ id: itemId, type: "mutateHandbookTemplate" });
  const isPending = useTypedSelector((state) => state.handBookReducer.loadings)[key];

  const onSubmitEdit = useCallback(
    (vals: any, { getState }: any) => {
      const { initialValues } = getState();
      const changedValues = getChangedFields(vals, initialValues);
      if (Object.keys(changedValues).length > 0) {
        dispatch(localChangeHandbookTemplate(itemId, changedValues, handbookLvl));
      }
    },
    [itemId, handbookLvl]
  );

  const isChecked = editings.checked[itemId];

  const onCheckItem = useCallback(() => {
    dispatch(handBookActions.localCheckTemplateItem({ id: itemId, isChecked: !Boolean(isChecked), lvl: handbookLvl }));
  }, [itemId, isChecked, handbookLvl]);

  return {
    onSubmitEdit,
    isPending,
    isEditing,
    isChecked,
    onCheckItem,
  };
};

export default useHandBooksTemplatesRow;
